import { connect } from 'react-redux';
//import { withRouter } from 'react-router';

import FooterComponent from '../components/footer/FooterComponent';
import { isTosUpdated } from '../store/actions/tos';

const mapStateToProps = ({ tos: { isLoading, isUpdated } }, { isLandingOrEntryPage }) => ({
    isLoading,
    isLandingOrEntryPage,
    tosTitle: `${isUpdated ? 'UPDATED ' : ''}Terms of Use and Privacy Policy`,
});

const mapDispatchToProps = {
    isTosUpdated,
};

// const mergePros = {
//     { history, tos, isLoading, isLandingOrEntryPage, ...stateProps},
//     { }
// }

export default connect(mapStateToProps, mapDispatchToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/containers/FooterContainer.js